/* global yaCounterNUMBERID */
import helpers from '../helpers';
// import scrollDepth from 'scroll-depth';

function start15SecTimeout() {
	clearTimeout(helpers.$window.data('timeout15Sec'));

	helpers.$window.data('timeout15Sec', setTimeout(() => {
		gtag('event', 'time_on_page_15s');
	}, 15000));
}

function cardClick() {
	let cardEls = document.querySelectorAll('.heroes__item');
	cardEls.forEach((item) => {
		item.addEventListener('click', () => {
			const numberCard = item.closest('.heroes__item').querySelector('.heroes__num .value').textContent;

			gtag('event', 'card_click', {
				'event_label': numberCard
			});
		});
	});
}

function sliderNavClick() {
	let navEls = document.querySelectorAll('.heroes__item .swiper-button-next, .heroes__item .swiper-button-prev');
	navEls.forEach((item) => {
		item.addEventListener('click', () => {
			const numberCard = item.closest('.heroes__item').querySelector('.heroes__num .value').textContent;

			gtag('event', 'card_photo_slide', {
				'event_label': numberCard
			});
		});
	});
}

function modalNavClick() {
	let modalNavEls = document.querySelectorAll('.remodal .swiper-button-next, .remodal .swiper-button-prev');
	modalNavEls.forEach((item) => {
		item.addEventListener('click', () => {
			const numberCard =  item.closest('.remodal').querySelector('.heroes__num .value').textContent;

			gtag('event', 'card_photo_slide', {
				'event_label': numberCard
			});
		});
	});
}

function favClick() {
	let favEls = document.querySelectorAll('.heroes__item .js-like');
	favEls.forEach((item) => {
		item.addEventListener('click', () => {
			let type;
			const numberCard =  item.closest('.heroes__item').querySelector('.heroes__num .value').textContent;

			if (item.classList.contains('heroes__likes--active')) {
				type = 'on';
			} else {
				type = 'off';
			}

			gtag('event', 'vote', {
				'event_category': `vote ${type}`,
				'event_label': numberCard
			});
		});
	});
}

function favModalClick() {
	let favEls = document.querySelectorAll('.remodal .js-like');
	favEls.forEach((item) => {
		item.addEventListener('click', () => {
			let type;
			const numberCard =  item.closest('.remodal').querySelector('.heroes__num .value').textContent;

			if (item.classList.contains('heroes__likes--active')) {
				type = 'on';
			} else {
				type = 'off';
			}

			gtag('event', 'vote', {
				'event_category': `vote ${type}`,
				'event_label': numberCard
			});
		});
	});
}

// scrollDepth({
// 	userTiming: false,
// 	pixelDepth: false,
// 	gtmOverride: true,
// 	eventHandler(data) {
// 		gtag('event', 'scroll_depth', {
// 			'event_label': `${data.eventLabel}%`
// 		});
// 	},
// });

/**
* Создать куки запись
* @param {string} path Обязательное, ссылка/путь
*/
// function virtualHit(path) {
// 	if (window.ga) {
// 		ga('set', 'page', path);
// 		ga('send', 'pageview', path);
// 		// Не всегда используются
// 		// ga('rbcspec.set', 'page', path);
// 		// ga('rbcspec.send', 'pageview', path);
// 	}

// 	// NUMBERID нужно менять для каждого проекта, так же используется в PUG
// 	if (window.yaCounterNUMBERID) {
// 		yaCounterNUMBERID.hit(path);
// 	}
// }

function init() {
	start15SecTimeout();
	sliderNavClick();
	modalNavClick();
	favClick();
	favModalClick();
	cardClick();
}

export default {
	init,
	start15SecTimeout,
	// virtualHit,
};
